export default __webpack_public_path__ + "static/media/student.755f9a3f.jpg";